import { Component, OnInit,Optional, Inject } from '@angular/core';
import { MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { statusCodes } from 'ew-common-lib';
import { EwMaTableListService } from '../ew-ma-table-list.service';

@Component({
  selector: 'app-select-session',
  templateUrl: './select-session.component.html',
  styleUrls: ['./select-session.component.scss']
})
export class SelectSessionComponent implements OnInit {
  selected = 'option1';
  sessionData:any;
  webinar_id:any;
  domain_id:any;
  sessionList:any;
  selectedSession:number;
  golive_url:any;
  constructor(
    private tableListService: EwMaTableListService,
    public dialogRef: MatDialogRef<SelectSessionComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      this.sessionData = data.sessionData;
      this.sessionList = data.sessionData.sessionList;
      this.webinar_id = this.sessionData.webinar_id;
      this.domain_id = this.sessionData.domain_id;
      this.golive_url = this.sessionData.golive_url;
    }

    redirectToLiveRoom():void{

      if(this.selectedSession != 0){
        const model = {
          "webinar_id": this.webinar_id,
          "domain_id": this.domain_id,
          "session_id": this.selectedSession,
          "value": ""
        }
        
        this.sessionList.forEach(element => {
          if(element.session_id == this.selectedSession){
            model.value = element.value;
          }
        });

        console.log(model);

        this.tableListService.hoa(model).subscribe((response: any) => {
          console.log(response);
          
          if (response.status.code == statusCodes.SUCCESS) {
            let url = this.golive_url+"?webinar_id="+this.webinar_id+"&did="+this.domain_id+"&sid="+response.data; //this.selectedSession;
            console.log(url);
            window.location.href = url;
          }
        });
        
      }

    }

    closeDailog(): void {
      this.dialogRef.close();
    }

  ngOnInit(): void {
    this.sessionData = this.data.sessionData;
    this.sessionList = this.data.sessionData.sessionList;
    this.webinar_id = this.sessionData.webinar_id;
    this.domain_id = this.sessionData.domain_id;
    this.golive_url = this.sessionData.golive_url;
  }

}
